import styled from "@emotion/styled"
import { Button } from "@mui/material"
import { ApartIcon, Container, NewText, PublicIcon } from "ui"
import { extractProperty } from "utils"
import SectionTitles from "./SectionTitles"

const StyledButtonsDiv = styled.div`
  padding-top: 40px;
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: center;
  justify-content: center;
`

const StyledButton = styled(Button)<{ isActive: boolean }>`
  height: 117px;
  box-shadow: 0px 4px 12px 0px #00000029;

  width: 183px;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: 16px;
  border: ${(p) => (p.isActive ? "2px solid #2768A3" : "none")};
  ${(props) => props.theme.breakpoints.up("md")} {
    height: 137px;
  }
  svg {
    path {
      stroke: ${(p) => (p.isActive ? "#2768A3" : "#6F6F6F")};
    }
  }
  :hover {
    text-decoration: none;
  }
`

type Props = {
  title: string
  subtitle: string
  filteredFiles: any
  handleDestinationChange: any
  destionation: any
}

const DocumentDestination = ({
  title,
  subtitle,
  filteredFiles,
  handleDestinationChange,
  destionation,
}: Props) => {
  const allDestinations = filteredFiles.map((file: any) => {
    const destination = extractProperty(file, "fileDestination")?.[0]
    return extractProperty(destination, "fileDestination")
  })

  // Get unique destinations by filtering out duplicates
  const uniqueDestinations = [...new Set(allDestinations.filter(Boolean))] as string[]

  const fileDestinations = uniqueDestinations.map((destinationName) => ({
    destinationName,
  }))

  return (
    <Container>
      <SectionTitles title={title} subtitle={subtitle} />
      <StyledButtonsDiv>
        {fileDestinations.map((destination, index) => (
          <StyledButton
            key={index}
            onClick={() => handleDestinationChange(destination.destinationName)}
            isActive={destionation === destination.destinationName}
          >
            {destination.destinationName === "דירה" ? <ApartIcon /> : <PublicIcon />}
            <NewText
              component={"p"}
              desktopFontSize={20}
              color={destionation === destination.destinationName ? "#000000" : "#6f6f6f"}
            >
              {destination.destinationName}
            </NewText>
          </StyledButton>
        ))}
      </StyledButtonsDiv>
    </Container>
  )
}

export default DocumentDestination
